import { array, mixed, object, type InferType, boolean } from 'yup'

export const photoSlideshowSchema = object({
  images: array(
    mixed<File | ContentFile>(),
  ).min(1).required(),
  grayscale: boolean().default(false),
})

export interface PhotoSlideshowPayload extends InferType<typeof photoSlideshowSchema> {}
